/**
 * --------------------------------------------------
 * Module to make things sticky filtering Module
 *
 * @module Sticky
 * --------------------------------------------------
 */

export default {
    _$stickyElem: null,
    _startingPositions: [],
    _$stickyClass: 'is-sticky',

    setup: function () {
        
        // Get sticky elements 
        this._$stickyElem = $('.rt-js-sticky');

        // If no sticky elements, exit
        if (this._$stickyElem.length === 0) return;

        // Store positions for every elem
        this._$stickyElem.each((index, elem) => {
            this._startingPositions[index] = $(elem).offset().top;
        });

        // Get start position
        this._startPos = this._$stickyElem.offset().top;

        // Add event listeners
        this.listeners();
    },

    // Add event listeners for scroll
    listeners: function () {
        const _self = this;
        // add scroll event listener and call scroll handler
        document.addEventListener('scroll', () => {
            window.requestAnimationFrame(() => {
                _self.onScroll();
            })
        });
    },

    // Function to handle scroll event
    onScroll: function () {
        const scrollPos = $(window).scrollTop();

        // Add classes to each element based on its position
        this._$stickyElem.each((i, elem) => {
            if (scrollPos > this._startingPositions[i]) {
                $(elem).addClass(this._$stickyClass);
            } else {
                $(elem).removeClass(this._$stickyClass);
            }
        });
    }
}